import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { environment } from "../environments/environment";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { getAuth, provideAuth } from "@angular/fire/auth";
import { ReactiveFormsModule } from "@angular/forms";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatIconModule } from "@angular/material/icon";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatButtonModule } from "@angular/material/button";
import { NgxsModule } from "@ngxs/store";
import { NgxsReduxDevtoolsPluginModule } from "@ngxs/devtools-plugin";
import { UserState } from "./states/user.state";
import { NgxsRouterPluginModule } from "@ngxs/router-plugin";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { ServiceWorkerModule } from "@angular/service-worker";
import { NgxsLoggerPluginModule } from "@ngxs/logger-plugin";

// NGXS dev plugins are loaded only outside production. Logger prints every
// action (including `Login` with email/password) to the browser console, and
// Devtools exposes the same payloads through the Redux Devtools extension —
// neither belongs in a production bundle.
const NGXS_DEV_PLUGINS = environment.production
  ? []
  : [
      NgxsReduxDevtoolsPluginModule.forRoot(),
      NgxsLoggerPluginModule.forRoot(),
    ];
import { UIState } from "./states/ui.state";
import { ClientState } from "./states/client.state";
import { DeviceDetectorService } from "ngx-device-detector";
import { MatMenuModule } from "@angular/material/menu";
import { MatTooltipModule } from "@angular/material/tooltip";
import { initializeApp, provideFirebaseApp, getApp } from "@angular/fire/app";
import { PerformanceModule } from "@angular/fire/performance";
import { provideStorage, getStorage } from "@angular/fire/storage";
import {
  provideFirestore,
  getFirestore,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from "@angular/fire/firestore";
import { ProfileModalModule } from "./pages/profile/profile-modal/profile-modal.module";

@NgModule({ declarations: [AppComponent],
    exports: [
        MatToolbarModule,
        MatIconModule,
        MatButtonModule,
        MatSnackBarModule,
        MatMenuModule,
    ],
    bootstrap: [AppComponent],
    imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        MatToolbarModule,
        MatIconModule,
        MatSidenavModule,
        NgxsModule.forRoot([UserState, ClientState, UIState]),
        NgxsRouterPluginModule.forRoot(),
        ...NGXS_DEV_PLUGINS,
        MatButtonModule,
        MatMenuModule,
        MatTooltipModule,
        ProfileModalModule,
        ServiceWorkerModule.register("ngsw-worker.js", {
            enabled: environment.production,
        }),
        PerformanceModule,
    ],
    providers: [
        DeviceDetectorService,
        provideFirebaseApp(() => initializeApp(environment.firebase)),
        provideAuth(() => getAuth()),
        provideStorage(() => getStorage()),
        provideFirestore(() => {
            // Reuse the FirebaseApp registered by provideFirebaseApp above.
            const app = getApp();
            try {
                return initializeFirestore(
                    app,
                    {
                        localCache: persistentLocalCache({
                            tabManager: persistentMultipleTabManager(),
                        }),
                    },
                    environment.firestore.databaseId
                );
            } catch {
                // initializeFirestore can only be called once per (app, dbId).
                // On HMR or route reloads the second call throws — fall back
                // to the existing instance.
                return getFirestore(app, environment.firestore.databaseId);
            }
        }),
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class AppModule {}
